import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

import s from './DealerAdsLeasingCard.css';

class DealerAdsLeasingCard extends React.Component {
  static propTypes = {
    fullPrice: PropTypes.oneOfType([PropTypes.string, PropTypes.shape()]),
    year: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    make: PropTypes.shape().isRequired,
    maker: PropTypes.string.isRequired,
    model: PropTypes.shape().isRequired,
  };
  static defaultProps = {
    year: null,
    fullPrice: null,
  };

  render() {
    const { fullPrice, year, make, maker, model } = this.props;

    return (
      <div className={s.root}>
        <div className={s.title}>
          {(maker && maker.title) || (make && make.title)} {model && model.title}{' '}
          <div className={s.similarYear}>{year}</div>
        </div>
        {fullPrice &&
          <div className={cx(s.similarPrice)}>
            {fullPrice}
          </div>}
      </div>
    );
  }
}

export default withStyles(s)(DealerAdsLeasingCard);



// WEBPACK FOOTER //
// ./src/desktop/components/AdvertCarCard/DealerAdsLeasingCard/DealerAdsLeasingCard.js